import React, { useMemo } from 'react';
import { withRouter } from 'react-router-dom';
import { compose } from 'redux';
import PropTypes from 'prop-types';
import { useQuery } from '@apollo/client';
import withProjectSidebar from '../../components/with-project-sidebar';
import tabs from '../../constants/tabs';
import QuestionVideoFeatures from './question-video-features';
import GET_PROJECT_TESTERS from './graphql';

const QuestionVideo = (props) => {
  const {
    project,
  } = props;

  const { data, loading: testersLoading } = useQuery(GET_PROJECT_TESTERS, {
    variables: { id: project?.id },
    fetchPolicy: 'cache-and-network',
    nextFetchPolicy: 'cache-first',
  });

  const testers = useMemo(() => (data && data?.project?.testers), [data]);

  return (
    <QuestionVideoFeatures
      project={project}
      testers={testers}
      testersLoading={testersLoading}
    />
  );
};

QuestionVideo.propTypes = {
  project: PropTypes.oneOfType([PropTypes.object]).isRequired,
};

export default compose(
  withRouter,
  withProjectSidebar({
    selectedTab: tabs.PROJECT,
    showSideBar: false,
  }),
)(QuestionVideo);
